declare var Highcharts: any;
import { Component, OnInit, OnDestroy, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { DashboardService } from '../../../dashboard/services/dashboard.service';
import { Utils } from '../../Utils';
import {merge} from 'lodash';
import { DatePipe} from "@angular/common";

@Component({
  selector: 'app-display-eia-pareto',
  templateUrl: './display-eia-pareto.component.html'
})
export class DisplayEiaParetoComponent implements OnInit, OnDestroy {

  //@Input() inputChart;
  @Input() chartId;
  elementId = 'chart-';
  _chart: any;
  theChart: any;
  subscription: any;
  temperatureArr: any;
  plots: any;
  recordRange: any;
  normalRange: any;
  temperatureForecastArr = [];
  recordLow: any;
  

  @ViewChild('chartTable') public chartEl: ElementRef;
  constructor(public dashboardService: DashboardService) { }

  ngOnInit() {
    this.elementId += this.chartId;

    this.subscription = this.dashboardService.getTemperatureData().subscribe(
        json=> {
          /*map forecast and actual data plot objects*/
          let getMapFunction = function(type) {
            return function(element) {
              return {
                y: element[1],
                temperatureType: type
              }
            };
          };

          var actualItems = json[0].data.map(getMapFunction('actual'));
          var forecastItems = json[1].data.map(getMapFunction('forecast'));

          this.temperatureArr = actualItems;
          this.temperatureForecastArr = forecastItems;

          var plotsTemp = [];
          var startDate =  new Date(json[3].data[0][0]);
          this.temperatureArr.forEach(function(element,index){
            var plotDate = new Date(startDate);
            plotDate.setDate(startDate.getDate()+index);
            plotsTemp.push(Utils.dateAsMMMDD(plotDate));
          });

          this.plots = plotsTemp;


          //set the column ranges for record
          var recordRanges = [];
          json[3].data.forEach(function(element){
            var tempArray = [element[1],element[2]];
            recordRanges.push(tempArray);
          });
          this.recordRange = recordRanges;

          //set the column ranges for normal range
          var normalRanges = [];
          json[2].data.forEach(function(element){
            var tempArray = [element[1],element[2]];
            normalRanges.push(tempArray);
          });
          this.normalRange = normalRanges;


          //set low value for y axis
            var recordlows = this.recordRange.map(function(element){
              return element[0];
            });
            this.recordLow = Math.min.apply(Math, recordlows);

        },
        null,
        ()=>{

          this.theChart = {
            
            chart: {
              logo : Highcharts.logos.none,
              height: '225'
            },
            credits: {
              enabled: false
            },

            title: {
              text: 'Daily Lower 48 average temperatures'
            },
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom'
            },

            xAxis: {
              categories:this.plots,
                plotLines: [{
                    color: Highcharts.eia_grey,
                    width: 2,
                    value: 6.5,
                    dashStyle: 'Dash',
                    label: {
                        text: 'report week',
                        align: 'right',
                        rotation: 0,
                        y: -5,
                        x:-10
                    }
                },
                    {
                        color: 'rgba(0,0,0,0)',
                        width: 2,
                        value: 6.5,
                        dashStyle: 'Dash',
                        label: {
                            text: 'current week',
                            align: 'left',
                            rotation: 0,
                            y: -5,
                            x:10
                        }
              }]
            },

            yAxis: {
              title: {
                text: 'degrees Fahrenheit'
              },
              min: null,
              max: null,
              tickInterval : 5
            },
            tooltip: {
              shared: true,
                formatter: function(){
                var formatter= this;
                var splitDate = formatter.x.split(' ');

                var toolTipString = '';
                    toolTipString += '<div>'+ Utils.monthsInYear[splitDate[0]] + ' ' + splitDate[1] +'</div><br>';

                    formatter.points.forEach(function(element){
                      if(element.series.name.indexOf('range') > -1){
                        toolTipString += '<div><b>'+ element.series.name.toLowerCase() + ': </b>' + element.point.low + ' to ' + element.point.high  +
                            '°F</div><br>';
                      }
                      else{
                        toolTipString += '<div><b>'+element.point.temperatureType+': </b>' + element.point.y + '°F </div>';

                      }
                    });
                return toolTipString;
              }
            },

            plotOptions: {
              columnrange: {
                grouping: false
              },
              spline: {
                // dataLabels:{
                //   //enabled:false
                // },
                color:'rgb(135, 1, 19)',
                lineWidth:0,
                states: {
                  hover: {
                    enabled:false,
                    lineWidthPlus:0
                  }
                }
              }
            },

            series: [{
              name: 'record range',
                type: 'columnrange',
              pointPadding: 0,
              color: 'rgb(200, 200, 200)',
              borderColor: 'rgba(0,0,0,0)',
              data: this.recordRange
            },

              {
                name: 'normal range',
                type:'columnrange',
                pointPadding: 0.2,
                color: 'rgb(146, 146, 146)',
                borderColor: 'rgba(0,0,0,0)',
                data: this.normalRange
              },

              {
                name: 'actual',
                type: 'spline',
                data:this.temperatureArr,
                // tooltip: {
                //   pointFormat: '<span style="font-weight: bold; color: {series.color}">{point.temperatureType}</span>:<b>{point.y:.1f}°F</b>' // point.forecast
                // },
                marker: {
                  radius: 8,
                  symbol: 'diamond',
                  lineColor: null,
                  lineWidth: '2',
                  fillColor: '#0096D7',

                },
                label:{
                  enabled:false
                }
              },
              {
                name: "forecast",
                type: "spline",
                data:this.temperatureForecastArr,
                marker: {
                  radius: 8,
                  symbol: 'diamond',
                  lineColor: '#0096D7',
                  fillColor: 'rgba(0,0,0,0)',
                  lineWidth: '2'

                }
              }
            ]
          };

          this.setupChart();
        }
    );
  }

  private setupChart(){
    if (this.chartEl && this.chartEl.nativeElement) {

      this.theChart.chart = merge({}, this.theChart.chart, {
        logo: Highcharts.logos.none,
        renderTo: this.chartEl.nativeElement
      });

      this._chart = new Highcharts.Chart(this.theChart);
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    if(this._chart !== undefined) {
      this._chart.destroy();
      this._chart = undefined;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/share-modules/eia-charts/display-eia-pareto/display-eia-pareto.component.ts